import { useMemo } from 'react';

import { RunSchema } from '@/types/schema';
import { enumerateKeys } from '@/utils/enumerate-keys';

export function useSuggestionsFromRunSchema(runSchema?: RunSchema): string[] {
  return useMemo(() => {
    return runSchema ? getSuggestionsFromRunSchema(runSchema) : [];
  }, [runSchema]);
}

export function getSuggestionsFromRunSchema(runSchema: RunSchema): string[] {
  if (!runSchema || Object.keys(runSchema).length === 0) {
    return [];
  }
  const allSuggestions: string[] = [];
  if (runSchema.inputs) {
    const allInputKeys = enumerateKeys({
      obj: runSchema.inputs,
      prefix: 'run.inputs',
      includeArrayIndices: false,
      includeNegativeIndices: false,
      includeWildcard: false,
    });
    allSuggestions.push(...allInputKeys);
  }
  if (runSchema.outputs) {
    const allOutputKeys = enumerateKeys({
      obj: runSchema.outputs,
      prefix: 'run.outputs',
      includeArrayIndices: false,
      includeNegativeIndices: false,
      includeWildcard: false,
    });
    allSuggestions.push(...allOutputKeys);
  }

  allSuggestions.push('run.error');

  return [...new Set(allSuggestions)].sort();
}
